import React from 'react';
import { array, func } from 'prop-types';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

const CurrentRefinements = ({ items, refine, toggleActiveFilter }) => (
    <div className="ais-CurrentRefinements">
        <ul className="ais-CurrentRefinements-list">
            {items.map(item => (
                <li className="ais-CurrentRefinements-itemt" key={item.label}>
                    <span className="ais-CurrentRefinements-label">
                        {item.label}
                    </span>
                    <span className="ais-CurrentRefinements-category">
                        <button
                            className="ais-CurrentRefinements-delete"
                            onClick={event => {
                                toggleActiveFilter(item.id, true);
                                event.preventDefault();
                                refine(item.value);
                            }}
                        >
                            ✕
                        </button>
                    </span>
                </li>
            ))}
        </ul>
    </div>
);

/* eslint-disable react/no-typos */
/* eslint-disable react/forbid-prop-types */
CurrentRefinements.propTypes = {
    items: array.isRequired,
    refine: func,
    toggleActiveFilter: func.isRequired
};

CurrentRefinements.defaultProps = { refine: null };

const CustomCurrentRefinements = connectCurrentRefinements(CurrentRefinements);
export default CustomCurrentRefinements;



// WEBPACK FOOTER //
// ./src/sections/algolia-filter/CustomCurrentRefinements/index.jsx